import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vw97v1k7ax: FaireBrandEntity = {
  token: "b_vw97v1k7ax",
  type: "brand",
  name: "Speks",
  avatarUrl:
    "https://cdn.faire.com/fastly/ee3c51a6924f2bf2d7be721800e10846b6f2c056ec7508c4808d4982e214e0fc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ee3b246fd75bbde93daba15ec6c9b50e61e71a61c79ab95cba3cae93ae4703d1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ee3c51a6924f2bf2d7be721800e10846b6f2c056ec7508c4808d4982e214e0fc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee3b246fd75bbde93daba15ec6c9b50e61e71a61c79ab95cba3cae93ae4703d1.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 81,
  isInsider: true,
  description:
    "Hey there, we’re Speks. We’re a small team creating the world’s most satisfying desk toys. We work so your work can be more fun.\n\nSpeks is based in Brooklyn, baby! At our HQ, we design, prototype, and take Instagram pictures of all of your favorite fidgets. It’s like a mad science lab but with better decoration and way more Diet Coke. From big, creative concepts to detailed spreadsheets our team is there every step of the way.\n\nAt Speks, we take adult fun seriously. But we also take safety seriously. While our products are safe with proper use for adults, they must be kept away from all children. If magnets are swallowed or inhaled, they can lead to serious injury and even death. If it’s suspected that a magnet was swallowed, please take immediate action and contact your medical professional.",
  meta: {
    source: "api",
    importedAt: "2026-07-17T19:04:04.720Z",
    importedBy: "entity-db-cli",
  },
};
